import { Box, CardContent, Grid, Stack, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import React from "react";
import Gene20Box from "../../../Components/Gene20Box/Gene20Box";
import TypedCredits from "../../../Components/landingPage/typedCredits";
import BillBoard from "../PresentationBillboard/billboard";
import IntroFooter from "../presentationFooter/introFooter";

const useStyles = makeStyles((theme) => ({
  root: {
    margin: "0px",
    padding: "0",
    // position: "absolute",
    display: "flex",
    justifyContent: "space-between",
    alignContent: "center",
    height: "100vh",
    width: "100%",
    backgroundImage: `linear-gradient(44deg , #ffffff77 , #ff00ff99)`,
    paddingTop: "10vh",
    zIndex: 1,
    // width: "100%",
  },
  Gene20Header: {
    // height: "40vh",
    width: "100%",
    // position: "absolute",
    display: "flex",
    // padding: "auto 50%",
    align: "center",
    alignContent: "center",
    alignItems: "center",
  },
}));
function Gene20Header(props) {
  const classes = useStyles();
  return (
    <Gene20Box className={classes.root}>
      <Grid container>
        <Grid item xs={12} align="center" className={classes.Gene20Header}>
          <CardContent align="center">
            <Stack align="center">
              <Typography
                variant="h1"
                color="secondary"
                sx={{ letterSpacing: "0.5rem" }}
              >
                welcome to
              </Typography>
              <Typography
                variant="h4"
                color="secondary"
                component="h2"
                fontWeight={700}
              >
                the mall of the internet
              </Typography>
            </Stack>
          </CardContent>
        </Grid>
        <Grid item xs={12} align="center" className={classes.Gene20Header}>
          <BillBoard />
        </Grid>

        <Grid item xs={12} align="center" className={classes.Gene20Header}>
          <IntroFooter phone={props.phone} tablet={props.tablet} />
        </Grid>
      </Grid>
    </Gene20Box>
  );
}

export default Gene20Header;
